var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InviteList',{attrs:{"isForAdmin":true,"organization":_vm.organization}})
}
var staticRenderFns = []

export { render, staticRenderFns }